export enum DATE_LOCALE {
  en = 'en-GB', // English
  cs = 'cs-CZ', // Čeština
  da = 'da-DK', // Dansk
  de = 'de-DE', // Deutsch
  es = 'es-ES', // Español
  fr = 'fr-FR', // Français
  hi = 'hi-IN', // हिन्दी
  it = 'it-IT', // Italiano
  ja = 'ja-JP', // 日本語
  ko = 'ko-KR', // 한국어
  nl = 'nl-NL', // Nederlands
  id = 'id-ID', // Bahasa Indonesia
  no = 'no-NO', // Norsk
  pl = 'pl-PL', // Polski
  pt = 'pt-PT', // Português
  ru = 'ru-RU', // Русский
  sv = 'sv-SE', // Svenska
  th = 'th-TH', // ไทย
  tr = 'tr-TR', // Türkçe
  uk = 'uk-UA', // Українська
  zh = 'zh-CN', // 繁體中文
  vi = 'vi-TV', // Tiếng Việt
}
